export default class ClientModel {
    constructor () {

        this.id = null
        this.company = null
        this.firstname = ""
        this.surname = ""
        this.email = ""
        this.phone = ""
        this.mobile = ""
        
    }
}